/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, Stack, Typography, TextField } from '@mui/material';

import { PaymentGatewayType, paymentGatewayTypes } from '../../store/modules/merchant/types';
import { pspInputForms } from '../../store/modules/merchant/constants';
import { FormSection } from './FormSection';

type PaymentGatewayFormValues = {
  paymentGateway: PaymentGatewayType | 'none';
  paymentGatewayData?: Record<string, string>;
};

type Props = {
  readOnly?: boolean;
  fieldsRequired?: boolean;
};

export const PaymentGatewayFields = ({ readOnly = false, fieldsRequired = true }: Props) => {
  const {
    register,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext<PaymentGatewayFormValues>();

  const selectedPaymentGateway = watch('paymentGateway');

  return (
    <FormSection title="Payment Gateway">
      <Controller
        control={control}
        name="paymentGateway"
        render={({ field }) => (
          <TextField
            label="Payment Gateway"
            select
            {...field}
            disabled={readOnly}
            onChange={(e) => {
              field.onChange(e);
              setValue('paymentGatewayData', {});
            }}
            error={!!errors.paymentGateway}
            helperText={errors.paymentGateway?.message}
          >
            <MenuItem value="none" sx={{ fontWeight: 500 }}>
              No Payment Gateway
            </MenuItem>
            {paymentGatewayTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
      {selectedPaymentGateway !== 'none' && (
        <Stack
          spacing={2}
          sx={{
            borderRadius: '8px',
            backgroundColor: 'grey.100',
            border: '1px solid',
            borderColor: 'grey.400',
            p: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              color: 'common.black',
            }}
          >
            {pspInputForms[selectedPaymentGateway].title} required data
          </Typography>
          <Stack spacing={2}>
            {pspInputForms[selectedPaymentGateway].fields.map(
              (field: { name: string; label: string }) => (
                <TextField
                  key={field.name}
                  label={field.label}
                  sx={{ backgroundColor: 'white' }}
                  {...register(`paymentGatewayData.${field.name}`)}
                  required={fieldsRequired}
                  disabled={readOnly}
                  error={!!errors.paymentGatewayData?.[field.name]}
                  helperText={errors.paymentGatewayData?.[field.name]?.message}
                />
              ),
            )}
          </Stack>
        </Stack>
      )}
    </FormSection>
  );
};
